import React from 'react'
import { Card } from 'react-bootstrap'
import demoqr from "../qr-code.png"

const Dashboard = () => {
  return (
    <div className='container'>
    <div className="row">
     <div className="col-md-4 offset-md-4">

    <Card style={{marginTop:"50px"}}>
    <Card.Img variant="top" src={demoqr}/>
  <Card.Body style={{textAlign:"center"}}>
    <Card.Title>Scan QR For Attendece</Card.Title>
    <Card.Text>
      Her Your can scan for your attendance
    </Card.Text>
  </Card.Body>
  
</Card>
        
</div>
</div>


    </div>
  )
}

export default Dashboard